import httpClient from './httpClient';

class AuditService {
  // Bulk sync data from Excel file (admin only)
  async bulkSyncData(file) {
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const response = await httpClient.post('/api/audit-bulk-sync', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error during bulk sync:', error);
      throw error;
    }
  }

  // Get audit logs (admin only)
  async getAuditLogs(page = 1, pageSize = 50, filters = {}) {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        page_size: pageSize.toString()
      });
      
      if (filters.user_id) params.append('user_id', filters.user_id);
      if (filters.action) params.append('action', filters.action);
      if (filters.target_collection) params.append('target_collection', filters.target_collection);
      if (filters.start_date) params.append('start_date', filters.start_date);
      if (filters.end_date) params.append('end_date', filters.end_date);
      // Add sorting parameters
      if (filters.sort_by) params.append('sort_by', filters.sort_by);
      if (filters.sort_order) params.append('sort_order', filters.sort_order);
      
      const response = await httpClient.get(`/api/audit-logs?${params}`);
      return response.data;
    } catch (error) {
      console.error('Error getting audit logs:', error);
      throw error;
    }
  }

  // Export audit logs (admin only)
  async exportAuditLogs(filters = {}) {
    try {
      const params = new URLSearchParams();
      
      if (filters.user_id) params.append('user_id', filters.user_id);
      if (filters.action) params.append('action', filters.action);
      if (filters.target_collection) params.append('target_collection', filters.target_collection);
      if (filters.start_date) params.append('start_date', filters.start_date);
      if (filters.end_date) params.append('end_date', filters.end_date);
      
      const response = await httpClient.get(`/api/audit-logs/export?${params}`);
      return response.data;
    } catch (error) {
      console.error('Error exporting audit logs:', error);
      throw error;
    }
  }

  // Get audit summary statistics (admin only)
  async getAuditSummary() {
    try {
      const response = await httpClient.get('/api/audit-logs/summary');
      return response.data;
    } catch (error) {
      console.error('Error getting audit summary:', error);
      throw error;
    }
  }
}

const auditService = new AuditService();
export default auditService;